<!--@format-->
<template>
    <div class="account-company-opportunities-widget purple-gradient-header">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Add Minimum Gross Margin for Opportunities</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <p>
                    Opportunities with margins below the set threshold require approval by an Admin
                    before being added to the sales pipeline; those at or above are automatically
                    approved and added.
                </p>
                <span class="bold">What is the Minimum Gross Margin for Opportunities?</span>
                <div class="margin-app-input-wrapper">
                    <app-input
                        v-model="minimumGrossMargin"
                        type="number"
                        step="1"
                        min="0"
                        placeholder="0"
                    />
                    %
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn transparent-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container" @click="updateMinimumGrossMargin">
                    <app-button> Save </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const AppInput = () => import('@/components/common/app-input');

const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');

import EventBus from '@/scripts/event-bus.js';
export default {
    name: 'account-company-opportunities-widget',

    components: {
        'app-button': AppButton,
        'app-input': AppInput,

        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            minimumGrossMargin: 0,
        };
    },

    created() {
        this.minimumGrossMargin = this.widget.options.account.minimumGrossMargin || 0;
    },

    methods: {
        updateMinimumGrossMargin() {
            EventBus.$emit('update:minimum-gross-margin', this.minimumGrossMargin);
            this.closeWidget();
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.account-company-opportunities-widget .widget-contents-container {
    text-align: left;
    font: normal normal normal 16px/19px Roboto;
    letter-spacing: 0px;
    color: #382153;
}

.account-company-opportunities-widget .widget-contents-container .transparent-btn {
    background: transparent;
    border: 1px solid #cac6cb;
    color: #382153;
}

.account-company-opportunities-widget .widget-contents-container .transparent-btn:hover {
    background: #e1e0e5;
}

.account-company-opportunities-widget .content-wrapper .margin-app-input-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
}

.account-company-opportunities-widget .content-wrapper .margin-app-input-wrapper .app-input {
    max-width: 70px;
}

.account-company-opportunities-widget.widget .content-wrapper {
    padding: 22px 35px;
}
</style>
